import { createSelector } from '@reduxjs/toolkit';
import { currentChatOpponentIdSelector } from '../currentChatOpponentIdSelector';
import { userProfileClientInfoSelector } from './userProfileClientInfoSelector';

export const userProfileClientInfoForAnalyticsSelector = createSelector(
  [userProfileClientInfoSelector, currentChatOpponentIdSelector],
  (clientInfo, clientId) => {
    if (!clientInfo) {
      return null;
    }

    const { searchInfo, statistics, recentlyWatchedOffers } = clientInfo;

    return { searchInfo, statistics, recentlyWatchedOffers, clientId };
  },
);
